import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Input, Table } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const SellerApiProducts = () => {
  const [token, setToken] = useState('');
  const crumbList = [
    { tittle: '외부 api 송출 내역', url: '' },
    { tittle: '외부 api 송출 내역 조회', url: '' }
  ];

  const columns = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Product Name',
      dataIndex: 'productName'
    },
    {
      title: 'Product Width',
      dataIndex: 'width'
    },
    {
      title: 'Product Height',
      dataIndex: 'height'
    },
    {
      title: 'Product Length',
      dataIndex: 'length'
    },
    {
      title: 'Unit of Dimension Measurements',
      dataIndex: 'demensionUnit'
    },
    {
      title: 'Product Weight',
      dataIndex: 'weight'
    },
    {
      title: 'Unit of Weight Measurement',
      dataIndex: 'weightUnit'
    },
    {
      title: 'Estimated Quantity',
      dataIndex: 'estimateQuantity'
    },
    {
      title: 'Average Monthly Sales',
      dataIndex: 'averageMonthSale'
    },
    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: 'EAN/UPC Barcode Number',
      dataIndex: 'eanUpc'
    },
    {
      title: 'Amazon Standard Identification Number',
      dataIndex: 'asin'
    },
    {
      title: 'Method of Packing',
      dataIndex: 'packedMethod'
    },
    {
      title: 'Method of Storage',
      dataIndex: 'storageMethod'
    },
    {
      title: 'Dangerous Goods Flag',
      dataIndex: 'dangerousGoods',
      render: (value: boolean) => (value ? 'true' : 'false')
    },
    {
      title: 'Lot Number of the Product',
      dataIndex: 'lotProduct'
    }
  ];

  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const fetchData = async (page: number) => {
    const res = await axios.get(
      `https://public-api.buskfulfillment.com/api/v1/seller/products?page=${page}`,
      {
        headers: {
          'X-Busk-Api-Token': token
        }
      }
    );
    console.log(res.data);
    setTotalPage(res.data.lastPage * 10);
    setData(res.data.data);
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={crumbList} />
      <div className="busk-container">
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: 20,
            marginBottom: 20
          }}
        >
          <Input
            placeholder="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <Button onClick={() => fetchData(0)}>Fetch</Button>
        </div>
        <Table
          pagination={{
            total: totalPage,
            current: currentPage,
            showSizeChanger: false,
            onChange: (page, limit) => {
              fetchData(page - 1);
              setCurrentPage(page);
            }
          }}
          columns={columns}
          scroll={{ x: 'max-content' }}
          dataSource={data}
        />
      </div>
    </div>
  );
};

export default SellerApiProducts;
